import { render, staticRenderFns } from "./AeButton.vue?vue&type=template&id=12fc471a&scoped=true"
import script from "./AeButton.vue?vue&type=script&lang=js"
export * from "./AeButton.vue?vue&type=script&lang=js"
import style0 from "./AeButton.vue?vue&type=style&index=0&id=12fc471a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc471a",
  null
  
)

export default component.exports